import React, { useContext, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button } from 'syngenta-react-components'
import { updateUserProfile } from '../../services/apiHelper'
import { AuthContext } from '../../services/context'

const UpdateProfileView = props => {
  const { auth, authDispatch } = useContext(AuthContext)
  const { register, handleSubmit, errors } = useForm()
  const [status, setStatus] = useState()

  const onSubmit = async values => {
    setStatus(<p>Loading...</p>)
    if (auth.userInfo?.user_id) {
      values.phone = values.phone.replace(/^(\+)|\D/g, '$1')
      const response = await updateUserProfile(
        auth.userInfo.user_id,
        values.first,
        values.last,
        values.phone
      )
      if(!response.errors){
        const newUserInfo = {
          user_id: auth.userInfo.user_id,
          first: values.first,
          last: values.last,
          phone: values.phone
        }
        authDispatch({ type: 'UPDATE_USER_PROFILE', payload: newUserInfo })
        props.closeHandler()
      } else {
        console.error(response.errors)
        if(response.errors[0].key_path === 'phone'){
          setStatus(<p className='c-red-700'>{response.errors[0].message}</p>)
        } else{
          setStatus(<p className='c-red-700'>Unable to update user information</p>)
        }
      }
    }
  }
  return (
    <div className='df fxdrc jcc aic'>
      <h1>Please Complete Profile</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='mt20'>
          <label>
            First name*
            <input
              type='text'
              name='first'
              ref={register({ required: true })}
            />
          </label>
        </div>
        <div className='mt20'>
          <label>
            Last name*
            <input type='text' name='last' ref={register({ required: true })} />
          </label>
        </div>
        <div className='mt20'>
          <label>
            Phone number*
            <input
              type='phone'
              name='phone'
              ref={register({ required: true,
                pattern: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/ })}
            />
          </label>
        </div>
        {((errors.phone  && errors.phone.type === 'required') || errors.first || errors.last) && (
          <p className='c-red-700 fz14 pb0 mb0'> All fields are required</p>
        )}
        {errors.phone && errors.phone.type === 'pattern' && (
          <p className='c-red-700 fz14 mt10 p0'>Please provide a valid phone number <br />ex. 919-999-9999, limited to 10 digits</p>
        )}
        <div className='mt20'
          data-testid='submitUpdateProfile'
        >
          <Button
            type='success'
            text='Submit'
            clickHandler={handleSubmit(onSubmit)}
          />
        </div>
        {status}
      </form>
    </div>
  )
}

export default UpdateProfileView
